// Blok onder het totaal in de tooltip van een outputgrafiek: de andere velden
// van de activiteit, samengevat over de registraties van de aangewezen datum
// (updateverzoek Team Sportclub, 2026-10-14).
//
// Nodig omdat de tooltips van OutputMultiLineGraph en OutputBarchart allebei
// dit blok tonen; één component houdt de tekst en de toestanden gelijk.

/** @typedef {import('../../../helpers/dataHelpers/summarizeOutputFields').FieldSummaryLine} FieldSummaryLine */

/**
 * @typedef {object} OutputFieldSummaries
 * @property {'idle'|'loading'|'ready'|'error'} status - Van useOutputFieldResults
 * @property {Object<string, FieldSummaryLine[]>} byDate - Van summarizeOutputFields
 */

/**
 * @param {object} props
 * @param {OutputFieldSummaries} [props.fieldSummaries] - Leeg bij grafieken zonder activiteitsvelden
 * @param {string} props.label - De datum van het aangewezen punt ('12-5-2026')
 * @returns {JSX.Element|null}
 */
const OutputFieldsTooltipSection = ({ fieldSummaries, label }) => {
    if (!fieldSummaries) return null

    // Eerst 'weet ik niet', dan pas 'leeg'.
    // AI-CONTEXT: See docs/pitfalls.md#ui-empty-state-claims-absence-while-loading
    if (fieldSummaries.status === 'loading') {
        return <p className="output-fields-tooltip output-fields-tooltip--status">Velden laden…</p>
    }
    if (fieldSummaries.status === 'error') {
        return (
            <p className="output-fields-tooltip output-fields-tooltip--status">
                De velden van de activiteit konden niet geladen worden.
            </p>
        )
    }

    const lines = fieldSummaries.byDate?.[label]
    if (fieldSummaries.status !== 'ready' || !lines || lines.length === 0) return null

    return (
        <dl className="output-fields-tooltip">
            {lines.map((line, i) => (
                <div key={`${i}-${line.label}`} className="output-fields-tooltip-row">
                    <dt>{line.label}</dt>
                    <dd>{line.value}</dd>
                </div>
            ))}
        </dl>
    )
}

export default OutputFieldsTooltipSection
